/* tslint:disable */
/* eslint-disable */
/**
 * grpc/tasks/service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { TasksCreateTaskRequest } from '../models'
// @ts-ignore
import { TasksCreateTaskResponse } from '../models'
// @ts-ignore
import { TasksCreateTaskTypeRequest } from '../models'
// @ts-ignore
import { TasksCreateTaskTypeResponse } from '../models'
// @ts-ignore
import { TasksDeleteTaskResponse } from '../models'
// @ts-ignore
import { TasksDeleteTaskTypeResponse } from '../models'
// @ts-ignore
import { TasksGetHealthResponse } from '../models'
// @ts-ignore
import { TasksGetTaskResponse } from '../models'
// @ts-ignore
import { TasksListMandatoryIncompleteResponse } from '../models'
// @ts-ignore
import { TasksListTaskPeopleResponse } from '../models'
// @ts-ignore
import { TasksListTaskTypesResponse } from '../models'
// @ts-ignore
import { TasksListTasksResponse } from '../models'
// @ts-ignore
import { TasksReorderTaskTypesRequest } from '../models'
// @ts-ignore
import { TasksReorderTaskTypesResponse } from '../models'
// @ts-ignore
import { TasksServiceUpdateTaskBody } from '../models'
// @ts-ignore
import { TasksServiceUpdateTaskTypeBody } from '../models'
// @ts-ignore
import { TasksUpdateTaskResponse } from '../models'
// @ts-ignore
import { TasksUpdateTaskTypeResponse } from '../models'
/**
 * TasksServiceApi - axios parameter creator
 * @export
 */
export const TasksServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Заводит задачу. Если задан template_id, вызов идемпотентен: повторная генерация задачи этапа возвращает уже существующую, а не заводит вторую.
     * @param {TasksCreateTaskRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceCreateTask: async (
      body: TasksCreateTaskRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('tasksServiceCreateTask', 'body', body)
      const localVarPath = `/api/v1/tasks`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Заводит тип задачи. Имя приходит в локали автора, остальные локали дописывает translator-service. Требует pipeline:update — та же аудитория, что у конструктора воронки.
     * @param {TasksCreateTaskTypeRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceCreateTaskType: async (
      body: TasksCreateTaskTypeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('tasksServiceCreateTaskType', 'body', body)
      const localVarPath = `/api/v1/tasks/types`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Снимает задачу (мягкое удаление): сделка может вернуться на этап, и тогда задача оживает той же самой.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceDeleteTask: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tasksServiceDeleteTask', 'id', id)
      const localVarPath = `/api/v1/tasks/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Удаляет тип задачи. Системный тип удалить нельзя. Тип, которым уже помечены задачи, удаляется только с force: тогда задачи остаются без типа.
     * @param {string} id
     * @param {boolean} [force] Удалять, даже если типом помечены задачи: они останутся без типа.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceDeleteTaskType: async (
      id: string,
      force?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tasksServiceDeleteTaskType', 'id', id)
      const localVarPath = `/api/v1/tasks/types/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (force !== undefined) {
        localVarQueryParameter['force'] = force
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Проба живости через API-gateway: отвечает, если сервис поднят и маршрут доехал до gRPC. Публичный метод — токена не требует.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceGetHealth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tasks/health`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceGetTask: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tasksServiceGetTask', 'id', id)
      const localVarPath = `/api/v1/tasks/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Незакрытые обязательные задачи этапа — гейт перехода сделки вперёд. Зовёт deals своим сервисным токеном.
     * @param {TasksServiceListMandatoryIncompleteEntityTypeEnum} [entityType]
     * @param {string} [entityId]
     * @param {string} [stageId] Этап, задачи которого проверяем. Пусто — все этапы сущности.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceListMandatoryIncomplete: async (
      entityType?: TasksServiceListMandatoryIncompleteEntityTypeEnum,
      entityId?: string,
      stageId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tasks/mandatory-incomplete`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (entityType !== undefined) {
        localVarQueryParameter['entityType'] = entityType
      }

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId
      }

      if (stageId !== undefined) {
        localVarQueryParameter['stageId'] = stageId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Справочник менеджеров для этого не годится: он отвечает на вопрос «кому можно назначить клиента» (роли manager/hos/ceo), а задачи ведут ещё и саппорт, и админы, и уволенные, и автоматизации сервисов — отобрать их в фильтре было нечем. Список людей обязан приходить из самих задач.  Без права calendar:read_all отвечает одной строкой про вызывающего: чужих задач он всё равно не увидит, и предлагать чужие имена в фильтре — обман.
     * @summary Кто встречается в задачах: исполнители и авторы со счётчиками. Из этого списка борда строит фильтры «Исполнители» и «Авторы».
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceListTaskPeople: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tasks/people`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Справочник типов задач. Читают все аутентифицированные: тип показывается на карточке задачи и в фильтрах борды.
     * @param {boolean} [includeInactive] true — вернуть и деактивированные типы. Формам они не нужны, конструктору и фильтрам борды нужны: задачи со снятым типом никуда не делись.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceListTaskTypes: async (
      includeInactive?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tasks/types`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeInactive !== undefined) {
        localVarQueryParameter['includeInactive'] = includeInactive
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Без права calendar:read_all выдача принудительно сужается до своих задач — тех, где вызывающий исполнитель или автор.
     * @summary Кросс-сущностный список задач: карточка сделки, карточка клиента и борда «Задачи» ходят сюда же, отличаются только фильтрами.
     * @param {TasksServiceListTasksEntityTypeEnum} [entityType] Сузить до задач одной сущности: обе части пары задаются вместе.
     * @param {string} [entityId]
     * @param {Array<string>} [assigneeIds] Исполнители. Пусто и без calendar:read_all — только свои задачи.
     * @param {Array<string>} [authorIds] Авторы задач.
     * @param {Array<TasksServiceListTasksStatusesEnum>} [statuses]
     * @param {Array<string>} [taskTypeIds]
     * @param {boolean} [withoutType] true — только типизированные задачи без типа («Без типа» на борде).
     * @param {string} [dueFrom]
     * @param {string} [dueTo]
     * @param {string} [createdFrom]
     * @param {string} [createdTo]
     * @param {string} [completedFrom]
     * @param {string} [completedTo]
     * @param {boolean} [overdue] true — только просроченные: срок в прошлом и статус не DONE.
     * @param {TasksServiceListTasksSortByEnum} [sortBy]
     * @param {boolean} [sortDesc]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceListTasks: async (
      entityType?: TasksServiceListTasksEntityTypeEnum,
      entityId?: string,
      assigneeIds?: Array<string>,
      authorIds?: Array<string>,
      statuses?: Array<TasksServiceListTasksStatusesEnum>,
      taskTypeIds?: Array<string>,
      withoutType?: boolean,
      dueFrom?: string,
      dueTo?: string,
      createdFrom?: string,
      createdTo?: string,
      completedFrom?: string,
      completedTo?: string,
      overdue?: boolean,
      sortBy?: TasksServiceListTasksSortByEnum,
      sortDesc?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tasks`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (entityType !== undefined) {
        localVarQueryParameter['entityType'] = entityType
      }

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId
      }

      if (assigneeIds) {
        localVarQueryParameter['assigneeIds'] = assigneeIds
      }

      if (authorIds) {
        localVarQueryParameter['authorIds'] = authorIds
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses
      }

      if (taskTypeIds) {
        localVarQueryParameter['taskTypeIds'] = taskTypeIds
      }

      if (withoutType !== undefined) {
        localVarQueryParameter['withoutType'] = withoutType
      }

      if (dueFrom !== undefined) {
        localVarQueryParameter['dueFrom'] =
          (dueFrom as any) instanceof Date ? (dueFrom as any).toISOString() : dueFrom
      }

      if (dueTo !== undefined) {
        localVarQueryParameter['dueTo'] =
          (dueTo as any) instanceof Date ? (dueTo as any).toISOString() : dueTo
      }

      if (createdFrom !== undefined) {
        localVarQueryParameter['createdFrom'] =
          (createdFrom as any) instanceof Date ? (createdFrom as any).toISOString() : createdFrom
      }

      if (createdTo !== undefined) {
        localVarQueryParameter['createdTo'] =
          (createdTo as any) instanceof Date ? (createdTo as any).toISOString() : createdTo
      }

      if (completedFrom !== undefined) {
        localVarQueryParameter['completedFrom'] =
          (completedFrom as any) instanceof Date
            ? (completedFrom as any).toISOString()
            : completedFrom
      }

      if (completedTo !== undefined) {
        localVarQueryParameter['completedTo'] =
          (completedTo as any) instanceof Date ? (completedTo as any).toISOString() : completedTo
      }

      if (overdue !== undefined) {
        localVarQueryParameter['overdue'] = overdue
      }

      if (sortBy !== undefined) {
        localVarQueryParameter['sortBy'] = sortBy
      }

      if (sortDesc !== undefined) {
        localVarQueryParameter['sortDesc'] = sortDesc
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Меняет порядок типов в справочнике: список приходит целиком, в нужном порядке.
     * @param {TasksReorderTaskTypesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceReorderTaskTypes: async (
      body: TasksReorderTaskTypesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('tasksServiceReorderTaskTypes', 'body', body)
      const localVarPath = `/api/v1/tasks/types/reorder`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Правит задачу: не переданные поля остаются как были. Смена статуса на DONE проставляет completed_at, обратная смена его снимает.
     * @param {string} id
     * @param {TasksServiceUpdateTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceUpdateTask: async (
      id: string,
      body: TasksServiceUpdateTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tasksServiceUpdateTask', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('tasksServiceUpdateTask', 'body', body)
      const localVarPath = `/api/v1/tasks/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Правит тип задачи. Не переданные поля остаются как были; имя переводится заново только когда его прислали.
     * @param {string} id
     * @param {TasksServiceUpdateTaskTypeBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceUpdateTaskType: async (
      id: string,
      body: TasksServiceUpdateTaskTypeBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tasksServiceUpdateTaskType', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('tasksServiceUpdateTaskType', 'body', body)
      const localVarPath = `/api/v1/tasks/types/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TasksServiceApi - functional programming interface
 * @export
 */
export const TasksServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TasksServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Заводит задачу. Если задан template_id, вызов идемпотентен: повторная генерация задачи этапа возвращает уже существующую, а не заводит вторую.
     * @param {TasksCreateTaskRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceCreateTask(
      body: TasksCreateTaskRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksCreateTaskResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceCreateTask(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceCreateTask']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Заводит тип задачи. Имя приходит в локали автора, остальные локали дописывает translator-service. Требует pipeline:update — та же аудитория, что у конструктора воронки.
     * @param {TasksCreateTaskTypeRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceCreateTaskType(
      body: TasksCreateTaskTypeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksCreateTaskTypeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceCreateTaskType(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceCreateTaskType']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Снимает задачу (мягкое удаление): сделка может вернуться на этап, и тогда задача оживает той же самой.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceDeleteTask(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksDeleteTaskResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceDeleteTask(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceDeleteTask']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Удаляет тип задачи. Системный тип удалить нельзя. Тип, которым уже помечены задачи, удаляется только с force: тогда задачи остаются без типа.
     * @param {string} id
     * @param {boolean} [force] Удалять, даже если типом помечены задачи: они останутся без типа.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceDeleteTaskType(
      id: string,
      force?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksDeleteTaskTypeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceDeleteTaskType(
        id,
        force,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceDeleteTaskType']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Проба живости через API-gateway: отвечает, если сервис поднят и маршрут доехал до gRPC. Публичный метод — токена не требует.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceGetHealth(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksGetHealthResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceGetHealth(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceGetHealth']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceGetTask(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksGetTaskResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceGetTask(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceGetTask']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Незакрытые обязательные задачи этапа — гейт перехода сделки вперёд. Зовёт deals своим сервисным токеном.
     * @param {TasksServiceListMandatoryIncompleteEntityTypeEnum} [entityType]
     * @param {string} [entityId]
     * @param {string} [stageId] Этап, задачи которого проверяем. Пусто — все этапы сущности.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceListMandatoryIncomplete(
      entityType?: TasksServiceListMandatoryIncompleteEntityTypeEnum,
      entityId?: string,
      stageId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<TasksListMandatoryIncompleteResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceListMandatoryIncomplete(
        entityType,
        entityId,
        stageId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceListMandatoryIncomplete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Справочник менеджеров для этого не годится: он отвечает на вопрос «кому можно назначить клиента» (роли manager/hos/ceo), а задачи ведут ещё и саппорт, и админы, и уволенные, и автоматизации сервисов — отобрать их в фильтре было нечем. Список людей обязан приходить из самих задач.  Без права calendar:read_all отвечает одной строкой про вызывающего: чужих задач он всё равно не увидит, и предлагать чужие имена в фильтре — обман.
     * @summary Кто встречается в задачах: исполнители и авторы со счётчиками. Из этого списка борда строит фильтры «Исполнители» и «Авторы».
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceListTaskPeople(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksListTaskPeopleResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceListTaskPeople(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceListTaskPeople']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Справочник типов задач. Читают все аутентифицированные: тип показывается на карточке задачи и в фильтрах борды.
     * @param {boolean} [includeInactive] true — вернуть и деактивированные типы. Формам они не нужны, конструктору и фильтрам борды нужны: задачи со снятым типом никуда не делись.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceListTaskTypes(
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksListTaskTypesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceListTaskTypes(
        includeInactive,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceListTaskTypes']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Без права calendar:read_all выдача принудительно сужается до своих задач — тех, где вызывающий исполнитель или автор.
     * @summary Кросс-сущностный список задач: карточка сделки, карточка клиента и борда «Задачи» ходят сюда же, отличаются только фильтрами.
     * @param {TasksServiceListTasksEntityTypeEnum} [entityType] Сузить до задач одной сущности: обе части пары задаются вместе.
     * @param {string} [entityId]
     * @param {Array<string>} [assigneeIds] Исполнители. Пусто и без calendar:read_all — только свои задачи.
     * @param {Array<string>} [authorIds] Авторы задач.
     * @param {Array<TasksServiceListTasksStatusesEnum>} [statuses]
     * @param {Array<string>} [taskTypeIds]
     * @param {boolean} [withoutType] true — только типизированные задачи без типа («Без типа» на борде).
     * @param {string} [dueFrom]
     * @param {string} [dueTo]
     * @param {string} [createdFrom]
     * @param {string} [createdTo]
     * @param {string} [completedFrom]
     * @param {string} [completedTo]
     * @param {boolean} [overdue] true — только просроченные: срок в прошлом и статус не DONE.
     * @param {TasksServiceListTasksSortByEnum} [sortBy]
     * @param {boolean} [sortDesc]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceListTasks(
      entityType?: TasksServiceListTasksEntityTypeEnum,
      entityId?: string,
      assigneeIds?: Array<string>,
      authorIds?: Array<string>,
      statuses?: Array<TasksServiceListTasksStatusesEnum>,
      taskTypeIds?: Array<string>,
      withoutType?: boolean,
      dueFrom?: string,
      dueTo?: string,
      createdFrom?: string,
      createdTo?: string,
      completedFrom?: string,
      completedTo?: string,
      overdue?: boolean,
      sortBy?: TasksServiceListTasksSortByEnum,
      sortDesc?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksListTasksResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceListTasks(
        entityType,
        entityId,
        assigneeIds,
        authorIds,
        statuses,
        taskTypeIds,
        withoutType,
        dueFrom,
        dueTo,
        createdFrom,
        createdTo,
        completedFrom,
        completedTo,
        overdue,
        sortBy,
        sortDesc,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceListTasks']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Меняет порядок типов в справочнике: список приходит целиком, в нужном порядке.
     * @param {TasksReorderTaskTypesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceReorderTaskTypes(
      body: TasksReorderTaskTypesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksReorderTaskTypesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceReorderTaskTypes(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceReorderTaskTypes']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Правит задачу: не переданные поля остаются как были. Смена статуса на DONE проставляет completed_at, обратная смена его снимает.
     * @param {string} id
     * @param {TasksServiceUpdateTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceUpdateTask(
      id: string,
      body: TasksServiceUpdateTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksUpdateTaskResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceUpdateTask(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceUpdateTask']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Правит тип задачи. Не переданные поля остаются как были; имя переводится заново только когда его прислали.
     * @param {string} id
     * @param {TasksServiceUpdateTaskTypeBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksServiceUpdateTaskType(
      id: string,
      body: TasksServiceUpdateTaskTypeBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TasksUpdateTaskTypeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksServiceUpdateTaskType(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TasksServiceApi.tasksServiceUpdateTaskType']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * TasksServiceApi - factory interface
 * @export
 */
export const TasksServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = TasksServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Заводит задачу. Если задан template_id, вызов идемпотентен: повторная генерация задачи этапа возвращает уже существующую, а не заводит вторую.
     * @param {TasksCreateTaskRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceCreateTask(
      body: TasksCreateTaskRequest,
      options?: any,
    ): AxiosPromise<TasksCreateTaskResponse> {
      return localVarFp
        .tasksServiceCreateTask(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Заводит тип задачи. Имя приходит в локали автора, остальные локали дописывает translator-service. Требует pipeline:update — та же аудитория, что у конструктора воронки.
     * @param {TasksCreateTaskTypeRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceCreateTaskType(
      body: TasksCreateTaskTypeRequest,
      options?: any,
    ): AxiosPromise<TasksCreateTaskTypeResponse> {
      return localVarFp
        .tasksServiceCreateTaskType(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Снимает задачу (мягкое удаление): сделка может вернуться на этап, и тогда задача оживает той же самой.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceDeleteTask(id: string, options?: any): AxiosPromise<TasksDeleteTaskResponse> {
      return localVarFp
        .tasksServiceDeleteTask(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Удаляет тип задачи. Системный тип удалить нельзя. Тип, которым уже помечены задачи, удаляется только с force: тогда задачи остаются без типа.
     * @param {string} id
     * @param {boolean} [force] Удалять, даже если типом помечены задачи: они останутся без типа.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceDeleteTaskType(
      id: string,
      force?: boolean,
      options?: any,
    ): AxiosPromise<TasksDeleteTaskTypeResponse> {
      return localVarFp
        .tasksServiceDeleteTaskType(id, force, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Проба живости через API-gateway: отвечает, если сервис поднят и маршрут доехал до gRPC. Публичный метод — токена не требует.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceGetHealth(options?: any): AxiosPromise<TasksGetHealthResponse> {
      return localVarFp.tasksServiceGetHealth(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceGetTask(id: string, options?: any): AxiosPromise<TasksGetTaskResponse> {
      return localVarFp.tasksServiceGetTask(id, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Незакрытые обязательные задачи этапа — гейт перехода сделки вперёд. Зовёт deals своим сервисным токеном.
     * @param {TasksServiceListMandatoryIncompleteEntityTypeEnum} [entityType]
     * @param {string} [entityId]
     * @param {string} [stageId] Этап, задачи которого проверяем. Пусто — все этапы сущности.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceListMandatoryIncomplete(
      entityType?: TasksServiceListMandatoryIncompleteEntityTypeEnum,
      entityId?: string,
      stageId?: string,
      options?: any,
    ): AxiosPromise<TasksListMandatoryIncompleteResponse> {
      return localVarFp
        .tasksServiceListMandatoryIncomplete(entityType, entityId, stageId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Справочник менеджеров для этого не годится: он отвечает на вопрос «кому можно назначить клиента» (роли manager/hos/ceo), а задачи ведут ещё и саппорт, и админы, и уволенные, и автоматизации сервисов — отобрать их в фильтре было нечем. Список людей обязан приходить из самих задач.  Без права calendar:read_all отвечает одной строкой про вызывающего: чужих задач он всё равно не увидит, и предлагать чужие имена в фильтре — обман.
     * @summary Кто встречается в задачах: исполнители и авторы со счётчиками. Из этого списка борда строит фильтры «Исполнители» и «Авторы».
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceListTaskPeople(options?: any): AxiosPromise<TasksListTaskPeopleResponse> {
      return localVarFp
        .tasksServiceListTaskPeople(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Справочник типов задач. Читают все аутентифицированные: тип показывается на карточке задачи и в фильтрах борды.
     * @param {boolean} [includeInactive] true — вернуть и деактивированные типы. Формам они не нужны, конструктору и фильтрам борды нужны: задачи со снятым типом никуда не делись.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceListTaskTypes(
      includeInactive?: boolean,
      options?: any,
    ): AxiosPromise<TasksListTaskTypesResponse> {
      return localVarFp
        .tasksServiceListTaskTypes(includeInactive, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Без права calendar:read_all выдача принудительно сужается до своих задач — тех, где вызывающий исполнитель или автор.
     * @summary Кросс-сущностный список задач: карточка сделки, карточка клиента и борда «Задачи» ходят сюда же, отличаются только фильтрами.
     * @param {TasksServiceListTasksEntityTypeEnum} [entityType] Сузить до задач одной сущности: обе части пары задаются вместе.
     * @param {string} [entityId]
     * @param {Array<string>} [assigneeIds] Исполнители. Пусто и без calendar:read_all — только свои задачи.
     * @param {Array<string>} [authorIds] Авторы задач.
     * @param {Array<TasksServiceListTasksStatusesEnum>} [statuses]
     * @param {Array<string>} [taskTypeIds]
     * @param {boolean} [withoutType] true — только типизированные задачи без типа («Без типа» на борде).
     * @param {string} [dueFrom]
     * @param {string} [dueTo]
     * @param {string} [createdFrom]
     * @param {string} [createdTo]
     * @param {string} [completedFrom]
     * @param {string} [completedTo]
     * @param {boolean} [overdue] true — только просроченные: срок в прошлом и статус не DONE.
     * @param {TasksServiceListTasksSortByEnum} [sortBy]
     * @param {boolean} [sortDesc]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceListTasks(
      entityType?: TasksServiceListTasksEntityTypeEnum,
      entityId?: string,
      assigneeIds?: Array<string>,
      authorIds?: Array<string>,
      statuses?: Array<TasksServiceListTasksStatusesEnum>,
      taskTypeIds?: Array<string>,
      withoutType?: boolean,
      dueFrom?: string,
      dueTo?: string,
      createdFrom?: string,
      createdTo?: string,
      completedFrom?: string,
      completedTo?: string,
      overdue?: boolean,
      sortBy?: TasksServiceListTasksSortByEnum,
      sortDesc?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: any,
    ): AxiosPromise<TasksListTasksResponse> {
      return localVarFp
        .tasksServiceListTasks(
          entityType,
          entityId,
          assigneeIds,
          authorIds,
          statuses,
          taskTypeIds,
          withoutType,
          dueFrom,
          dueTo,
          createdFrom,
          createdTo,
          completedFrom,
          completedTo,
          overdue,
          sortBy,
          sortDesc,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Меняет порядок типов в справочнике: список приходит целиком, в нужном порядке.
     * @param {TasksReorderTaskTypesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceReorderTaskTypes(
      body: TasksReorderTaskTypesRequest,
      options?: any,
    ): AxiosPromise<TasksReorderTaskTypesResponse> {
      return localVarFp
        .tasksServiceReorderTaskTypes(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Правит задачу: не переданные поля остаются как были. Смена статуса на DONE проставляет completed_at, обратная смена его снимает.
     * @param {string} id
     * @param {TasksServiceUpdateTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceUpdateTask(
      id: string,
      body: TasksServiceUpdateTaskBody,
      options?: any,
    ): AxiosPromise<TasksUpdateTaskResponse> {
      return localVarFp
        .tasksServiceUpdateTask(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Правит тип задачи. Не переданные поля остаются как были; имя переводится заново только когда его прислали.
     * @param {string} id
     * @param {TasksServiceUpdateTaskTypeBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksServiceUpdateTaskType(
      id: string,
      body: TasksServiceUpdateTaskTypeBody,
      options?: any,
    ): AxiosPromise<TasksUpdateTaskTypeResponse> {
      return localVarFp
        .tasksServiceUpdateTaskType(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * TasksServiceApi - object-oriented interface
 * @export
 * @class TasksServiceApi
 * @extends {BaseAPI}
 */
export class TasksServiceApi extends BaseAPI {
  /**
   *
   * @summary Заводит задачу. Если задан template_id, вызов идемпотентен: повторная генерация задачи этапа возвращает уже существующую, а не заводит вторую.
   * @param {TasksCreateTaskRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceCreateTask(body: TasksCreateTaskRequest, options?: RawAxiosRequestConfig) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceCreateTask(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Заводит тип задачи. Имя приходит в локали автора, остальные локали дописывает translator-service. Требует pipeline:update — та же аудитория, что у конструктора воронки.
   * @param {TasksCreateTaskTypeRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceCreateTaskType(
    body: TasksCreateTaskTypeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceCreateTaskType(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Снимает задачу (мягкое удаление): сделка может вернуться на этап, и тогда задача оживает той же самой.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceDeleteTask(id: string, options?: RawAxiosRequestConfig) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceDeleteTask(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Удаляет тип задачи. Системный тип удалить нельзя. Тип, которым уже помечены задачи, удаляется только с force: тогда задачи остаются без типа.
   * @param {string} id
   * @param {boolean} [force] Удалять, даже если типом помечены задачи: они останутся без типа.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceDeleteTaskType(id: string, force?: boolean, options?: RawAxiosRequestConfig) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceDeleteTaskType(id, force, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Проба живости через API-gateway: отвечает, если сервис поднят и маршрут доехал до gRPC. Публичный метод — токена не требует.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceGetHealth(options?: RawAxiosRequestConfig) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceGetHealth(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceGetTask(id: string, options?: RawAxiosRequestConfig) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceGetTask(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Незакрытые обязательные задачи этапа — гейт перехода сделки вперёд. Зовёт deals своим сервисным токеном.
   * @param {TasksServiceListMandatoryIncompleteEntityTypeEnum} [entityType]
   * @param {string} [entityId]
   * @param {string} [stageId] Этап, задачи которого проверяем. Пусто — все этапы сущности.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceListMandatoryIncomplete(
    entityType?: TasksServiceListMandatoryIncompleteEntityTypeEnum,
    entityId?: string,
    stageId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceListMandatoryIncomplete(entityType, entityId, stageId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Справочник менеджеров для этого не годится: он отвечает на вопрос «кому можно назначить клиента» (роли manager/hos/ceo), а задачи ведут ещё и саппорт, и админы, и уволенные, и автоматизации сервисов — отобрать их в фильтре было нечем. Список людей обязан приходить из самих задач.  Без права calendar:read_all отвечает одной строкой про вызывающего: чужих задач он всё равно не увидит, и предлагать чужие имена в фильтре — обман.
   * @summary Кто встречается в задачах: исполнители и авторы со счётчиками. Из этого списка борда строит фильтры «Исполнители» и «Авторы».
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceListTaskPeople(options?: RawAxiosRequestConfig) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceListTaskPeople(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Справочник типов задач. Читают все аутентифицированные: тип показывается на карточке задачи и в фильтрах борды.
   * @param {boolean} [includeInactive] true — вернуть и деактивированные типы. Формам они не нужны, конструктору и фильтрам борды нужны: задачи со снятым типом никуда не делись.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceListTaskTypes(includeInactive?: boolean, options?: RawAxiosRequestConfig) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceListTaskTypes(includeInactive, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Без права calendar:read_all выдача принудительно сужается до своих задач — тех, где вызывающий исполнитель или автор.
   * @summary Кросс-сущностный список задач: карточка сделки, карточка клиента и борда «Задачи» ходят сюда же, отличаются только фильтрами.
   * @param {TasksServiceListTasksEntityTypeEnum} [entityType] Сузить до задач одной сущности: обе части пары задаются вместе.
   * @param {string} [entityId]
   * @param {Array<string>} [assigneeIds] Исполнители. Пусто и без calendar:read_all — только свои задачи.
   * @param {Array<string>} [authorIds] Авторы задач.
   * @param {Array<TasksServiceListTasksStatusesEnum>} [statuses]
   * @param {Array<string>} [taskTypeIds]
   * @param {boolean} [withoutType] true — только типизированные задачи без типа («Без типа» на борде).
   * @param {string} [dueFrom]
   * @param {string} [dueTo]
   * @param {string} [createdFrom]
   * @param {string} [createdTo]
   * @param {string} [completedFrom]
   * @param {string} [completedTo]
   * @param {boolean} [overdue] true — только просроченные: срок в прошлом и статус не DONE.
   * @param {TasksServiceListTasksSortByEnum} [sortBy]
   * @param {boolean} [sortDesc]
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceListTasks(
    entityType?: TasksServiceListTasksEntityTypeEnum,
    entityId?: string,
    assigneeIds?: Array<string>,
    authorIds?: Array<string>,
    statuses?: Array<TasksServiceListTasksStatusesEnum>,
    taskTypeIds?: Array<string>,
    withoutType?: boolean,
    dueFrom?: string,
    dueTo?: string,
    createdFrom?: string,
    createdTo?: string,
    completedFrom?: string,
    completedTo?: string,
    overdue?: boolean,
    sortBy?: TasksServiceListTasksSortByEnum,
    sortDesc?: boolean,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceListTasks(
        entityType,
        entityId,
        assigneeIds,
        authorIds,
        statuses,
        taskTypeIds,
        withoutType,
        dueFrom,
        dueTo,
        createdFrom,
        createdTo,
        completedFrom,
        completedTo,
        overdue,
        sortBy,
        sortDesc,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Меняет порядок типов в справочнике: список приходит целиком, в нужном порядке.
   * @param {TasksReorderTaskTypesRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceReorderTaskTypes(
    body: TasksReorderTaskTypesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceReorderTaskTypes(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Правит задачу: не переданные поля остаются как были. Смена статуса на DONE проставляет completed_at, обратная смена его снимает.
   * @param {string} id
   * @param {TasksServiceUpdateTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceUpdateTask(
    id: string,
    body: TasksServiceUpdateTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceUpdateTask(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Правит тип задачи. Не переданные поля остаются как были; имя переводится заново только когда его прислали.
   * @param {string} id
   * @param {TasksServiceUpdateTaskTypeBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksServiceApi
   */
  public tasksServiceUpdateTaskType(
    id: string,
    body: TasksServiceUpdateTaskTypeBody,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksServiceApiFp(this.configuration)
      .tasksServiceUpdateTaskType(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const TasksServiceListMandatoryIncompleteEntityTypeEnum = {
  Invalid: 'TASK_ENTITY_TYPE_INVALID',
  Deal: 'TASK_ENTITY_TYPE_DEAL',
  Client: 'TASK_ENTITY_TYPE_CLIENT',
  Agent: 'TASK_ENTITY_TYPE_AGENT',
} as const
export type TasksServiceListMandatoryIncompleteEntityTypeEnum =
  (typeof TasksServiceListMandatoryIncompleteEntityTypeEnum)[keyof typeof TasksServiceListMandatoryIncompleteEntityTypeEnum]
/**
 * @export
 */
export const TasksServiceListTasksEntityTypeEnum = {
  Invalid: 'TASK_ENTITY_TYPE_INVALID',
  Deal: 'TASK_ENTITY_TYPE_DEAL',
  Client: 'TASK_ENTITY_TYPE_CLIENT',
  Agent: 'TASK_ENTITY_TYPE_AGENT',
} as const
export type TasksServiceListTasksEntityTypeEnum =
  (typeof TasksServiceListTasksEntityTypeEnum)[keyof typeof TasksServiceListTasksEntityTypeEnum]
/**
 * @export
 */
export const TasksServiceListTasksStatusesEnum = {
  Invalid: 'TASK_STATUS_INVALID',
  Todo: 'TASK_STATUS_TODO',
  InProgress: 'TASK_STATUS_IN_PROGRESS',
  Done: 'TASK_STATUS_DONE',
} as const
export type TasksServiceListTasksStatusesEnum =
  (typeof TasksServiceListTasksStatusesEnum)[keyof typeof TasksServiceListTasksStatusesEnum]
/**
 * @export
 */
export const TasksServiceListTasksSortByEnum = {
  Invalid: 'TASK_SORT_FIELD_INVALID',
  DueDate: 'TASK_SORT_FIELD_DUE_DATE',
  CreatedAt: 'TASK_SORT_FIELD_CREATED_AT',
  CompletedAt: 'TASK_SORT_FIELD_COMPLETED_AT',
  Priority: 'TASK_SORT_FIELD_PRIORITY',
} as const
export type TasksServiceListTasksSortByEnum =
  (typeof TasksServiceListTasksSortByEnum)[keyof typeof TasksServiceListTasksSortByEnum]
